import type React from "react";
import type { IRecentItem } from "../types";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { Container, Title, ItemName } from "./styledComponents";

interface TooltipContentProps {
    mainItem: IRecentItem;
    comparedItems: Array<IRecentItem>;
}

export const TooltipContent: React.FC<TooltipContentProps> = (props) => {
    return (
        <Container>
            <Title>
                <I18n>digitalmarketing.homepage.recents_widget.tooltip.main_item</I18n>
            </Title>
            <ItemName>{props.mainItem.name}</ItemName>
            <Title>
                <I18n>digitalmarketing.homepage.recents_widget.tooltip.vs</I18n>
            </Title>
            {props.comparedItems.map((item, index) => (
                <ItemName key={index}>{item.name}</ItemName>
            ))}
        </Container>
    );
};
